const mutations = {
  getReportReferrals: (state, report_referral) => {
    state.report_referral = report_referral;
  },
  getDetail: (state, report_referral_id) => {
    state.report_referral_id = report_referral_id;
  },
  getSlideScreen: (state, slide_referral) => {
    state.slide_referral = slide_referral;
  },
  postReportReferral: (state, new_report_referral) => {
    state.report_referral.push(new_report_referral);
  },
  updateReportReferrals: (state, new_status) => {
    state.report_referral = state.report_referral.map((report_referral) => {
      if (report_referral.id === new_status.report_referral_id) {
        return Object.assign({}, report_referral, new_status.status);
      }
      return report_referral;
    });
  },
  putReportReferral: (state, payload) => {
    state.report_referral = state.report_referral.map((report_referral) => {
      if (report_referral.report_referral_id === payload.id) {
        return Object.assign({}, report_referral, payload.formData);
      }
      return report_referral;
    });
  },
  delReportReferral(state, id) {
    const index = state.report_referral.findIndex(report_referral => report_referral.report_referral_id == id);
    state.report_referral.splice(index, 1);
  },
};

export default mutations;
